<template>
  <div>
    <div class="server-location-wrapper">
      <!-- Page Header -->
      <PageHeader :content="headerContent" :showButton="false"></PageHeader>

      <div v-for="s in servers" :key="s._id" class="server-item">
        <div class="server-info">
          <h3>{{ s.title }}</h3>
          <p>{{ s.description }}</p>
        </div>
      </div>

      <div v-for="s in locations" :key="s._id" class="server-details-wrapper">
        <label>Server Locations</label>
        <div class="server-details">
          <span class="table-tag green">{{ s.location }}</span>
          <img :src="getCountryFlag(s.country)" :alt="s.country" />
        </div>
      </div>
    </div>

    <div class="account-actions">
      <button
        class="btn btn-small btn-primary"
        @click="sendNotification('delete')"
      >
        Delete Account
      </button>
      <button
        class="btn btn-small btn-border"
        @click="sendNotification('download')"
      >
        Download Data
      </button>
    </div>
  </div>
</template>

<script>
// Libraries
import _ from "lodash";

// Components
import PageHeader from "@/components/dashboard/PageHeader";

export default {
  name: "DataSecurity",
  data() {
    return {
      lodash: _,
      showOptions: {
        headerShadow: false,
        lineLoader: false,
      },
      headerContent: {
        title: "Data Storage & Security",
      },
      servers: [
        {
          title: "Ticket data & PII",
          description:
            "Macha follows a zero-data-retention policy. We only store the AI-generated content we create — never customer data or ticket comments",
        },
        {
          title: "Knowledge sources",
          description:
            "This is data you’ve chosen to use as AI knowledge. It’s securely stored in vector form and typically contains no personal information.",
        },
      ],
      locations: [{ location: "Frankfurt, Germany [EU]", country: "germany" }],
      status: {
        show: false,
        status: "success",
        title: "We've receieved your request. Our team will reach out to you.",
      },
    };
  },
  props: {},
  watch: {},
  components: {
    PageHeader,
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
  },
  async mounted() {},
  methods: {
    // Get logo of country
    getCountryFlag(country) {
      let iconURL = `/assets/images/flags/${country}.jpg`;
      return iconURL;
    },

    // Send a notification to team for account actions
    async sendNotification(actionType) {
      this.$emit("sendAccountRequest", actionType);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.page-loader-wrapper {
  margin-top: 2rem;
}

.header-wrapper {
  border-bottom: none;
}

::v-deep .line-loader {
  position: fixed;
  z-index: 101;
  bottom: 0;
  left: 0;
}

.show-shadow {
  box-shadow: 0 0.5rem 0.7rem -0.5rem $boxShadowColor;
}

.server-item {
  margin-bottom: 2rem;

  .server-info {
    flex: 1;

    h3 {
      font-size: $normalFontSize;
      margin-bottom: 0.5rem;
    }

    p {
      opacity: $lightOpacity;
      font-size: $smallFontSize;
    }
  }
}

.server-location {
  font-weight: 600;
  display: inline-block;
  font-size: $smallerFontSize;
  background-color: $greenColor;
  color: lighten($greenColor, 50%);
  border: 1px solid lighten($greenColor, 20%);
  border-radius: 0.5rem;
  font-weight: $mediumFontWeight;
  padding: 0.25rem 0.85rem;
  margin-right: 0.75rem;
}

.server-details {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  margin-top: 0.75rem;

  img {
    width: 1.5rem;
    border-radius: 0.15rem;
  }
}

::v-deep .notification-message {
  bottom: auto;
  width: calc(100% - 5rem);
  top: 1.5rem;
  justify-content: center;
  background-color: $greenColor;
  border: 1px solid lighten($greenColor, 20%);

  .info-wrapper {
    h3 {
      color: darken($greenColor, 40%);
    }
  }

  .unicon svg {
    fill: darken($greenColor, 40%);
  }
}

.account-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  .btn-primary {
    background-color: lighten($redColor, 37.5%);
    color: darken($redColor, 30%);
    border: 1px solid lighten($redColor, 15%);

    &:hover {
      background-color: lighten($redColor, 30.5%);
      border: 1px solid darken($redColor, 25%);
    }
  }
}

.server-location-wrapper.card {
  margin: 0;
}

.security-document {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 0.75rem 0 2rem;
  gap: 0.5rem;

  ::v-deep {
    .unicon svg {
      fill: $greyColor;
      width: 1rem;
      transform: translateY(-2px);
    }
  }

  span {
    font-size: $smallerFontSize;
    color: $greyColor;
  }

  a {
    color: $purpleColor;
    font-weight: 500;
  }
}
.settings-scroll-block {
  padding: 1.5rem 0 3rem;
  overflow-y: auto;
}

.server-details-wrapper {
  margin-bottom: 1.5rem;

  label {
    display: block;
    font-weight: $mediumFontWeight;
    font-size: $smallerFontSize;
  }
}
</style>
